import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";
import { K } from "./apiServiceI18n";

const ITEM_META = {
  getData: { labelKey: K.GET_DATA, Icon: InputIcon },
  translateData: { labelKey: K.TRANSLATE_DATA, Icon: TranslateIcon },
  sendData: { labelKey: K.SEND_DATA, Icon: OutputIcon },
};

/**
 * Right rail workflow items tree for the API/Service wizard.
 */
export default function WorkflowItemsTreePanel({
  workflowLabel,
  items = [],
  activeItem = null,
}) {
  const { t } = useTranslation();
  const rootLabel = workflowLabel?.trim() || t(K.API_SVC_EM_DASH);

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        bgcolor: "grey.50",
        p: 1.5,
        height: { xs: "auto", md: "100%" },
        flex: { xs: "0 0 auto", md: 1 },
        minHeight: { xs: 280, md: 0 },
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 700, mb: 1, color: "text.secondary", flexShrink: 0 }}
      >
        {t(K.API_SVC_WORKFLOW_ITEMS)}
      </Typography>
      <List dense disablePadding sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <ListItemButton
          selected={!activeItem}
          sx={{
            borderRadius: 0.5,
            pl: 1,
            "&.Mui-selected": { bgcolor: "action.selected" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <AccountTreeOutlinedIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText
            primary={rootLabel}
            primaryTypographyProps={{ variant: "body2", fontWeight: 600 }}
          />
        </ListItemButton>

        {items.map((id) => {
          const meta = ITEM_META[id];
          if (!meta) return null;
          const { labelKey, Icon } = meta;
          const selected = activeItem === id;
          return (
            <ListItemButton
              key={id}
              selected={selected}
              sx={{
                borderRadius: 0.5,
                pl: 3,
                bgcolor: selected ? "grey.700" : "transparent",
                color: selected ? "common.white" : "text.primary",
                "&.Mui-selected": {
                  bgcolor: "grey.700",
                  color: "common.white",
                  "&:hover": { bgcolor: "grey.600" },
                },
                "&.Mui-selected .MuiListItemIcon-root": { color: "common.white" },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32, color: selected ? "inherit" : "text.secondary" }}>
                <Icon sx={{ fontSize: 18 }} />
              </ListItemIcon>
              <ListItemText
                primary={t(labelKey)}
                primaryTypographyProps={{ variant: "body2", fontWeight: selected ? 600 : 400 }}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
}
